(function () {
  'use strict';

  // Inject component styles once
  if (!document.getElementById('cart-date-check-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-date-check-styles';
    style.textContent = `
      .cart-date-checking {
        opacity: .75;
        cursor: wait !important;
      }
      .cart-date-spinner {
        display: inline-block;
        width: 1.2em;
        height: 1.2em;
        border: 2px solid rgba(255,255,255,.35);
        border-top-color: currentColor;
        border-radius: 50%;
        animation: _cdc-spin .6s linear infinite;
        margin-left: .6em;
        vertical-align: middle;
      }
      @keyframes _cdc-spin { to { transform: rotate(360deg); } }

      .cart-date-toast {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100001;
        width: min(92vw, 44rem);
        background: #fff;
        border: 1.5px solid #fbbf24;
        border-radius: .8rem;
        box-shadow: 0 4px 24px rgba(0,0,0,.14);
        padding: 1.4rem 1.6rem;
        animation: _cdc-up .22s ease;
        font-size: 1.4rem;
        line-height: 1.5;
      }
      @keyframes _cdc-up {
        from { opacity: 0; transform: translateX(-50%) translateY(1.2rem); }
        to   { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
      .cart-date-toast__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        margin-bottom: 1rem;
      }
      .cart-date-toast__title {
        font-weight: 700;
        font-size: 1.4rem;
        color: #92400e;
        margin: 0;
        line-height: 1.3;
      }
      .cart-date-toast__close {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 1.8rem;
        line-height: 1;
        color: #92400e;
        padding: 0;
        flex-shrink: 0;
        opacity: .65;
        transition: opacity .15s;
      }
      .cart-date-toast__close:hover { opacity: 1; }
      .cart-date-toast__list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: .6rem;
      }
      .cart-date-toast__list li {
        padding: .7rem .9rem;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: .5rem;
        color: #333;
        line-height: 1.4;
      }
      .cart-date-toast__list small {
        display: block;
        margin-top: .2rem;
        color: #92400e;
        font-size: 1.2rem;
      }
      @media (max-width: 749px) {
        .cart-date-toast {
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          transform: none;
          border-radius: 1.2rem 1.2rem 0 0;
          animation: _cdc-up-m .22s ease;
        }
        @keyframes _cdc-up-m {
          from { opacity: 0; transform: translateY(1.2rem); }
          to   { opacity: 1; transform: translateY(0); }
        }
      }
    `;
    document.head.appendChild(style);
  }

  const TOAST_ID = 'cart-date-check-toast';

  // #packeta_checkout is handled by the checkout-date-check app extension
  const BTN_SELECTOR = '.delivery-button, .cart__checkout-button:not(#packeta_checkout)';

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function fmtDate(iso) {
    const [y, m, d] = iso.split('-');
    return `${d}.${m}.${y}`;
  }

  function removeToast() {
    document.getElementById(TOAST_ID)?.remove();
  }

  function proceed(btn) {
    if (btn instanceof HTMLAnchorElement && btn.href) {
      location.href = btn.href;
    } else if (btn.form) {
      btn.form.requestSubmit ? btn.form.requestSubmit(btn) : btn.form.submit();
    }
  }

  function buildToast(btn, listItemsHtml) {
    removeToast();

    const titleText = btn.dataset.msgErrorTitle || 'Unable to proceed with order';
    const closeLabel = btn.dataset.msgClose || 'Close';

    const toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'cart-date-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');

    const header = document.createElement('div');
    header.className = 'cart-date-toast__header';

    const titleEl = document.createElement('p');
    titleEl.className = 'cart-date-toast__title';
    titleEl.textContent = titleText;
    header.appendChild(titleEl);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'cart-date-toast__close';
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', removeToast);
    header.appendChild(closeBtn);

    toast.appendChild(header);

    const list = document.createElement('ul');
    list.className = 'cart-date-toast__list';
    list.innerHTML = listItemsHtml;

    toast.appendChild(list);
    document.body.appendChild(toast);

    setTimeout(removeToast, 10000);
  }

  function showToast(btn, items, availability) {
    const seen = new Set();
    const blocked = items.filter(item => {
      const key = `${item.date}||${item.title}`;
      if (seen.has(key)) return false;
      seen.add(key);
      const info = availability[item.date];
      return item.kind === 'birthday' ? info?.birthdayAvailable === false : item.kind === 'late' ? info?.lateAvailable === false : info?.available === false;
    });

    const msgUnavailable = btn.dataset.msgUnavailable || 'Date not available';
    const msgInsufficient = btn.dataset.msgInsufficient || 'Not enough tickets';

    const html = blocked.map(item => {
      const info = availability[item.date];
      const remaining = item.kind === 'birthday' ? info.birthdayRemaining : item.kind === 'late' ? info.lateRemaining : info.remaining;
      const reason = remaining === 0 ? msgUnavailable : msgInsufficient;
      return `<li><strong>${escHtml(item.title)}</strong> &ndash; ${escHtml(fmtDate(item.date))}<br><small>${escHtml(reason)}</small></li>`;
    }).join('');

    buildToast(btn, html);
  }

  function showMissingDateToast(btn, titles) {
    const msgMissingDate = btn.dataset.msgMissingDate || 'This ticket has no date selected. Please remove it from your cart and select a new ticket with a date.';

    const html = titles.map(title => {
      return `<li><strong>${escHtml(title)}</strong><br><small>${escHtml(msgMissingDate)}</small></li>`;
    }).join('');

    buildToast(btn, html);
  }

  function setLoading(btn, on) {
    if (on) {
      btn.classList.add('cart-date-checking');
      const spinner = document.createElement('span');
      spinner.className = 'cart-date-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      btn.appendChild(spinner);
      btn.style.pointerEvents = 'none';
    } else {
      btn.classList.remove('cart-date-checking');
      btn.querySelector('.cart-date-spinner')?.remove();
      btn.style.pointerEvents = '';
    }
  }

  async function onDeliveryClick(e) {
    const btn = e.currentTarget;
    const raw = btn.dataset.datedItems;
    const rawLate = btn.dataset.lateDatedItems;
    const rawBirthday = btn.dataset.birthdayDatedItems;
    const rawMissing = btn.dataset.missingDateItems;

    let items = [];
    try { if (raw && raw !== '[]') items = JSON.parse(raw).map(i => ({ ...i, kind: 'main' })); } catch { items = []; }
    let lateItems = [];
    try { if (rawLate && rawLate !== '[]') lateItems = JSON.parse(rawLate).map(i => ({ ...i, kind: 'late' })); } catch { lateItems = []; }
    let birthdayItems = [];
    try { if (rawBirthday && rawBirthday !== '[]') birthdayItems = JSON.parse(rawBirthday).map(i => ({ ...i, kind: 'birthday' })); } catch { birthdayItems = []; }
    let missingItems = [];
    try { if (rawMissing && rawMissing !== '[]') missingItems = JSON.parse(rawMissing); } catch { missingItems = []; }

    const allItems = [...items, ...lateItems, ...birthdayItems];
    if (!allItems.length && !missingItems.length) return;

    e.preventDefault();

    if (missingItems.length) {
      showMissingDateToast(btn, missingItems);
      return;
    }

    setLoading(btn, true);

    const byDate = {};
    items.forEach(({ date, qty }) => { byDate[date] = (byDate[date] || 0) + qty; });
    const byDateLate = {};
    lateItems.forEach(({ date, qty }) => { byDateLate[date] = (byDateLate[date] || 0) + qty; });
    const byDateBirthday = {};
    birthdayItems.forEach(({ date, qty }) => { byDateBirthday[date] = (byDateBirthday[date] || 0) + qty; });

    const datesParam = Object.entries(byDate).map(([d, q]) => `${d}:${q}`).join(',');
    const lateDatesParam = Object.entries(byDateLate).map(([d, q]) => `${d}:${q}`).join(',');
    const birthdayDatesParam = Object.entries(byDateBirthday).map(([d, q]) => `${d}:${q}`).join(',');
    const query = [
      datesParam && `dates=${datesParam}`,
      lateDatesParam && `lateDates=${lateDatesParam}`,
      birthdayDatesParam && `birthdayDates=${birthdayDatesParam}`,
    ].filter(Boolean).join('&');

    let availability;
    try {
      const res = await fetch('/apps/calendar?' + query);
      if (!res.ok) { setLoading(btn, false); proceed(btn); return; }
      availability = await res.json();
    } catch {
      setLoading(btn, false);
      proceed(btn);
      return;
    }

    setLoading(btn, false);

    const hasBlocked = allItems.some(({ date, kind }) => {
      const info = availability[date];
      return kind === 'birthday' ? info?.birthdayAvailable === false : kind === 'late' ? info?.lateAvailable === false : info?.available === false;
    });
    if (hasBlocked) {
      showToast(btn, allItems, availability);
    } else {
      proceed(btn);
    }
  }

  function attach() {
    document.querySelectorAll(BTN_SELECTOR).forEach(btn => {
      btn.removeEventListener('click', onDeliveryClick);
      btn.addEventListener('click', onDeliveryClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  new MutationObserver(mutations => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.classList?.contains('delivery-button') ||
          node.querySelector?.('.delivery-button') ||
          node.querySelector?.('.cart__checkout-button:not(#packeta_checkout)')
        ) {
          attach();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  function parseIdArray(raw) {
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function applyCartUpdate(items) {
    document.querySelectorAll(BTN_SELECTOR).forEach(function (btn) {
      const passIds = new Set(parseIdArray(btn.dataset.passProductIds));
      const lateIds = new Set(parseIdArray(btn.dataset.lateProductIds));
      const birthdayIds = new Set(parseIdArray(btn.dataset.birthdayProductIds));
      const ticketIds = new Set(parseIdArray(btn.dataset.ticketProductIds));
      const multipliers = JSON.parse(btn.dataset.capacityMultipliers || '{}');

      const datedItems = [];
      const lateDatedItems = [];
      const birthdayDatedItems = [];
      const missingDateItems = [];
      items.forEach(function (item) {
        if (passIds.has(item.product_id)) return;
        const raw = item.properties && item.properties._selectedDate;
        if (!raw) {
          if (ticketIds.has(item.product_id)) missingDateItems.push(item.title);
          return;
        }
        let isoDate;
        try { isoDate = new Date(raw).toISOString().split('T')[0]; } catch (_) { return; }
        if (birthdayIds.has(item.product_id)) {
          birthdayDatedItems.push({ date: isoDate, title: item.title, qty: item.quantity });
        } else if (lateIds.has(item.product_id)) {
          const mult = multipliers[item.variant_id] || 1;
          lateDatedItems.push({ date: isoDate, title: item.title, qty: item.quantity * mult });
        } else {
          const mult = multipliers[item.variant_id] || 1;
          datedItems.push({ date: isoDate, title: item.title, qty: item.quantity * mult });
        }
      });

      btn.dataset.datedItems = JSON.stringify(datedItems);
      btn.dataset.lateDatedItems = JSON.stringify(lateDatedItems);
      btn.dataset.birthdayDatedItems = JSON.stringify(birthdayDatedItems);
      btn.dataset.missingDateItems = JSON.stringify(missingDateItems);
    });

    const hasPhysical = items.some(function (item) { return item.requires_shipping; });
    document.querySelectorAll('[data-checkout-variant="physical"]').forEach(function (el) {
      el.style.display = hasPhysical ? '' : 'none';
    });
    document.querySelectorAll('[data-checkout-variant="digital"]').forEach(function (el) {
      el.style.display = hasPhysical ? 'none' : '';
    });
  }

  // cart/add.js (product-form / quick-add) returns only the added line item,
  // not the full cart, so the cart-icon-bubble section (always requested
  // alongside the add) carries a full items snapshot for us to read back —
  // same request, no extra round trip.
  function itemsFromSections(sections) {
    if (!sections) { console.warn('[cart-date-check] no sections on cartUpdate event'); return null; }
    const html = sections['cart-icon-bubble'];
    if (!html) { console.warn('[cart-date-check] no cart-icon-bubble in sections', Object.keys(sections)); return null; }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-cart-date-check-items]');
    if (!script) { console.warn('[cart-date-check] data-cart-date-check-items script not found in cart-icon-bubble html', html); return null; }
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      console.warn('[cart-date-check] failed to parse cart-date-check-items json', script.textContent, err);
      return null;
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    const cartData = event && event.cartData;
    if (!cartData) return;

    const items = cartData.items || itemsFromSections(cartData.sections);
    if (items) {
      applyCartUpdate(items);
    } else {
      console.warn('[cart-date-check] cartUpdate event carried no usable items', event);
    }
  });

  // Public hook so other scripts (e.g. product-form.js blocking add-to-cart
  // for a dateless ticket) can reuse this same toast instead of duplicating it.
  window.CartDateCheck = {
    showMissingDateToast(titles, config) {
      showMissingDateToast({ dataset: config || {} }, titles);
    },
  };
})();
